import LoaderComponent from './LoaderComponent';

export {
    LoaderComponent
}